import { Controller } from "@hotwired/stimulus";

// Clicking a suggested match fills the unified member combobox with that selection.
// The ref is a typed token: "import:<id>" or "member:<id>".
export default class extends Controller {
  static values = {
    ref: String,
    label: String,
  };

  select(event) {
    event.preventDefault();
    const form = this.element.closest("form");
    if (!form) return;

    const hidden = form.querySelector('[data-forms--combobox-target="hidden"]');
    const input = form.querySelector('[data-forms--combobox-target="input"]');
    if (hidden) hidden.value = this.refValue || "";
    if (input) {
      input.value = this.labelValue || "";
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
    if (hidden) hidden.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
